import React, { useRef } from "react";
import { Formik, FormikProps } from "formik";
import * as Yup from "yup";
import { Form } from "react-bootstrap";

//App
import PageHeader from "../../../common/PageHeader/PageHeader";
import ActionBar from "../../../common/ActionBar/ActionBar";
import { Autocomplete, CheckboxList } from "../../../common/VFX-UI";

//Common
import { RoleClaimProps } from "../../../../types/roleClaim";
import { FormikTypeaheadOption } from "../../../../types";
import useComponentGeneralStyles from "../../../styles";

const validationSchema = Yup.object({
  roleId: Yup.mixed().required("Role is required"),
});

const RolePermissionsForm: React.FC<RoleClaimProps> = (props) => {
  const {
    initialVal,
    status,
    lookup,
    roleId,
    setRoleId,
    handleOnSubmit,
    onClose,
  } = props;

  const generalStyles = useComponentGeneralStyles();

  const formRef = useRef<FormikProps<any>>(null);

  const saveInput = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  const handleChangeRole = async (value: FormikTypeaheadOption[]) => {
    let roleId: string | null = null;
    if (value && value?.length > 0) {
      roleId = (value[0] as Record<string, string | number>)["value"] as string;
    }
    await setRoleId(roleId);
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <>
      <PageHeader>Permissions</PageHeader>
      <Formik
        initialValues={{ ...initialVal }}
        enableReinitialize
        innerRef={formRef}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleOnSubmit(values);
        }}
      >
        {() => {
          return (
            <Form>
              <div style={generalStyles.searchContainer}>
                <Autocomplete
                  clearButton={true}
                  name="roleId"
                  label="Role"
                  options={lookup?.roles ?? []}
                  onChange={(value) => handleChangeRole(value)}
                  defaultSelected={roleId != null ? [roleId] : []}
                />
              </div>
              <CheckboxList
                columns={3}
                label="Permission"
                name="claimId"
                options={lookup?.permissions ?? []}
              />
            </Form>
          );
        }}
      </Formik>
      <ActionBar
        cancelHandler={handleCancel}
        submitHandler={saveInput}
        submitText="Save"
        cancelText="Cancel"
        isLoading={status === "pending"}
      />
    </>
  );
};

export default RolePermissionsForm;
